export const ENGLISH_REGEX = {
    pattern: /^([A-Za-z0-9\s!-/:-@[-`{-~()[\]]+)?$/,
    message: 'Only English letters are allowed'
};

export const ARABIC_REGEX = {
    // eslint-disable-next-line no-misleading-character-class
    pattern: /^[\u0621-\u064A\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFD\uFE70-\uFEFF \u0600-\u0605\u060C\u061B\u061F\u064B-\u065F\u066A-\u066D\u0670\u06D4\u06D6-\u06ED0-9.,()]*$/u,
    message: 'Only Arabic letters are allowed'
};
